import {MsalInterceptorConfiguration, MsalGuardConfiguration 
} from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, InteractionType , LogLevel, PublicClientApplication  } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { RouteConstants } from './models';


const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
/************************************************* MSAL DEBUG *******************************************************************/ 
/* export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
  console.log(logLevel);
}  */

/************************************************* MSAL INSTANCES FACTORIES ******************************************************/

export function UsersMSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.backendService.clientId,
      authority: environment.backendService.authority,
      redirectUri: environment.backendService.redirectUri, 
      postLogoutRedirectUri: environment.backendService.logoutRedirectUri, 
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {
      allowRedirectInIframe: true,
      loggerOptions: {
        /* loggerCallback, */
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

/****************************************************************** MSAL GUARDS **************************************************/  
export function UsersMSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.backendService.scopes,
      // prompt: 'login',
      loginHint: getQueryParam( RouteConstants.LOGINHINT_PARAM ) || ''
    },
    loginFailedRoute: '/login-failed'
  };
}

/*********************************************** INTERCEPTORS CONFIG *******************************************************/
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {

  const protectedResourceMap = new Map<string, string[]>();

  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me',         ['user.read']);
  protectedResourceMap.set(`${environment.backendService.url}`,              environment.backendService.scopes);
 
  return {
    
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function getQueryParam(param: string): string | null {

  const url = new URL(window.location.href);
  
  const queryParams = new URLSearchParams(url.hash.split('?')[1]);
  
  return queryParams.get(param);
}

